import imgOutside from '../../assetsFr/buildings/school/outside.jpg';
import imgWasteWater from '../../assetsFr/buildings/school/waste-water.jpg';
import imgFireProtection from '../../assetsFr/buildings/school/fire-protection.jpg';
import imgHeating from '../../assetsFr/buildings/school/heating.jpg';
import imgWater from '../../assetsFr/buildings/school/water.jpg';
import { Building } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';

const schoolConfig: Building = {
    techSectors: [
        {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                    position: { x: 1177, y: 821 },
                    type: ProductType.AMAPORTER,
                },
                {
                    position: { x: 752, y: 893 },
                    type: ProductType.COMPACTA,
                },
                {
                    position: { x: 1601, y: 729 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
                {
                    position: { x: 1799, y: 745 },
                    type: ProductType.AMA_DRAINER_4_5,
                },
                {
                    position: { x: 1203, y: 631 },
                    type: ProductType.LEVELCONTROL_BASIC_2,
                },
            ],
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                    position: { x: 952, y: 910 },
                    type: ProductType.HYADUO_2_D_FL_COMPACT,
                },
            ],
        },
        {
            type: TechSector.HEATING,
            img: imgHeating,
            products: [
                {
                    position: { x: 278, y: 875 },
                    type: ProductType.BOAX_S_SF,
                },
                {
                    position: { x: 331, y: 850 },
                    type: ProductType.SERIE_2000,
                },
                {
                    position: { x: 415, y: 865 },
                    type: ProductType.ETANORM,
                },
                {
                    position: { x: 477, y: 815 },
                    type: ProductType.BOA_CONTROL_IMS,
                },
                {
                    position: { x: 595, y: 830 },
                    type: ProductType.SISTO_16_RGAMAXX,
                },
                {
                    position: { x: 770, y: 815 },
                    type: ProductType.BOA_CONTROL_DPR,
                },
                {
                    position: { x: 825, y: 830 },
                    type: ProductType.CALIO_PRO_PLUS_Z,
                },
                {
                    position: { x: 912, y: 780 },
                    type: ProductType.BOA_CONTROL_SBV,
                },
                {
                    position: { x: 992, y: 810 },
                    type: ProductType.CALIO_PRO_PLUS,
                },
                {
                    position: { x: 1065, y: 797 },
                    type: ProductType.BOA_RVK,
                },
                {
                    position: { x: 1150, y: 815 },
                    type: ProductType.ETALINE_Z,
                },

                {
                    position: { x: 1424, y: 737 },
                    type: ProductType.BOATRONIC_MP,
                },
            ],
        },
        {
            type: TechSector.WATER,
            img: imgWater,
            products: [
                {
                    position: { x: 318, y: 740 },
                    type: ProductType.AMA_DRAINER_BOX_UEBERFLUR,
                },
                {
                    position: { x: 360, y: 685 },
                    type: ProductType.SISTO_16_TWA,
                },
                {
                    position: { x: 450, y: 687 },
                    type: ProductType.KSB_SAFETY_BOOST,
                },
                {
                    position: { x: 535, y: 690 },
                    type: ProductType.SISTO_16_RGAMAXX,
                },
            ],
        },
],
    img: imgOutside,
};

export default schoolConfig;
